/* eslint-disable */
export enum Level {
  Lenient = 0,
  Strict
}
